<script lang="ts">
  import { cn } from "$utils/ui";

  let className = "";
  let hasBackground = false;
  let mainClass = "";

  export { className as class, mainClass, hasBackground };
</script>

<div
  class={cn(
    "flex-1 flex flex-col lg:flex-row relative",
    hasBackground ? "bg-background-gray dark:bg-background-dark" : "bg-background-light dark:bg-background-dark",
  )}
>
  <main class={cn("flex-1 flex flex-col py-5 sm:py-8 lg:py-10", mainClass)}>
    <div class={cn("px-6 lg:px-10 flex-1", className)}>
      <slot />
    </div>
  </main>
</div>
